import { create } from 'zustand'

export interface TransactionsSpinner {
  showSpinnerLoading: boolean
  setShowSpinnerLoading: (newShowTransactionLoading: boolean) => void
  numberOfFailedTransactions?: number
  setNumberOfFailedTransactions: (failedTransactions: number) => void
  openSpinnerDrawer: boolean
  setOpenSpinnerDrawer: (newOpenSpinnerDrawer: boolean) => void
  showSidebarWarning: boolean
  setShowSidebarWarning: (newShowSidebarWarning: boolean) => void
  showLoadingOnStock: boolean
  setShowLoadingOnStock: (newShowLoadingOnStock: boolean) => void
  shouldRefreshStock: boolean
  setShouldRefreshStock: (newShouldRefreshStock: boolean) => void
}

export const useTransactionsSpinnerStore = create<TransactionsSpinner>()((set, get) => ({
  showSpinnerLoading: false,
  setShowSpinnerLoading: (val: boolean) => {
    if (get().showSpinnerLoading !== val) set({ showSpinnerLoading: val })
  },

  numberOfFailedTransactions: 0,
  setNumberOfFailedTransactions: (val: number) => {
    if (get().numberOfFailedTransactions !== val) set({ numberOfFailedTransactions: val })
  },

  openSpinnerDrawer: false,
  setOpenSpinnerDrawer: (val: boolean) => {
    if (get().openSpinnerDrawer !== val) set({ openSpinnerDrawer: val })
  },

  showSidebarWarning: false,
  setShowSidebarWarning: (val: boolean) => {
    if (get().showSidebarWarning !== val) set({ showSidebarWarning: val })
  },

  showLoadingOnStock: false,
  setShowLoadingOnStock: (val: boolean) => {
    if (get().showLoadingOnStock !== val) set({ showLoadingOnStock: val })
  },

  shouldRefreshStock: false,
  setShouldRefreshStock: (val: boolean) => {
    if (get().shouldRefreshStock !== val) set({ shouldRefreshStock: val })
  },
}))
